import React from "react";
import { FaArrowRight } from "react-icons/fa";

const CTA = () => {
  return (
    <section className="bg-gray-900 rounded-2xl shadow-lg p-10 md:p-14">
      <div className="max-w-7xl mx-auto space-y-12">
        <h2 className="text-white text-4xl md:text-5xl font-bold leading-tight">
          Ready to simplify your payment process?
        </h2>
        <p className="text-lg text-gray-300 max-w-2xl mx-auto">
          Join thousands of growing businesses using TruPay to manage
          transactions, stay compliant, and accelerate revenue.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-6">
          <a
            href="#"
            className="bg-teal-500 text-white px-6 py-3 rounded-md font-semibold hover:bg-teal-600 transition"
          >
            Get Started Now
          </a>
          <a
            href="#"
            className="group flex items-center gap-2 text-teal-400 hover:text-white transition"
          >
            Learn More{" "}
            <FaArrowRight className="-rotate-45 group-hover:rotate-0 transition-transform duration-300" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
